// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_2U9apmVhbXxi91cPJ7om2n","dialog":"_21PmKVNCpAZd7Al-LfM9AM"};